export enum PERMISSION {
  // Globales
  MANAGE_ACCOUNT = "MANAGE_ACCOUNT",
  CREATE_USER = "CREATE_USER",
  UPDATE_USER = "UPDATE_USER",
  DELETE_USER = "DELETE_USER",
  LIST_USERS = "LIST_USERS",
  USER_DETAIL = "USER_DETAIL",
  CHANGE_PASSWORDS = "CHANGE_PASSWORDS",
  MI_TIENDA_GET_STORES = "MI_TIENDA_GET_STORES",
  MI_TIENDA_ACTIVATE_STORES = "MI_TIENDA_ACTIVATE_STORES",
  PARTNER_PORTAL_GET_STORES = "PARTNER_PORTAL_GET_STORES",
  PARTNER_PORTAL_ACTIVATE_STORES = "PARTNER_PORTAL_ACTIVATE_STORES",
  REPORTS = "REPORTS",
  CONTROL_TOWER = "CONTROL_TOWER",
  DEV_PORTAL = "DEV_PORTAL",
  HANDLE_ROLES = "HANDLE_ROLES",
  MANAGE_SETTLEMENT = "MANAGE_SETTLEMENT",

  // Retailer
  RETAILER_MANAGE = "RETAILER_MANAGE",
  RETAILER_READ = "RETAILER_READ",
  RETAILER_UPDATE = "RETAILER_UPDATE",
  RETAILER_UPDATE_WITH_INCENTIVE_SETTINGS = "RETAILER_UPDATE_WITH_INCENTIVE_SETTINGS",

  // Picking Points
  PP_MANAGE = "PP_MANAGE",
  PP_UPDATE = "PP_UPDATE",
  PP_CREATE = "PP_CREATE",
  PP_READ = "PP_READ",
  PP_DELETE = "PP_DELETE",
  ORDER_MANAGE = "ORDER_MANAGE",
  ORDER_CREATE = "ORDER_CREATE",
  ORDER_CANCEL = "ORDER_CANCEL",
  ORDER_REMOVE_DEBT = "ORDER_REMOVE_DEBT",
  ORDER_ADD_INCENTIVE = "ORDER_ADD_INCENTIVE",
  ORDER_POSITION = "ORDER_POSITION",
  ORDER_VALIDATE = "ORDER_VALIDATE",
  ORDER_HAND_RT = "ORDER_HAND_RT",
  ORDER_READY = "ORDER_READY",
  PP_UPDATE_WITH_INCENTIVE_SETTINGS = "PP_UPDATE_WITH_INCENTIVE_SETTINGS",
}

export const ManagePermissionGraph = {
  [PERMISSION.MANAGE_ACCOUNT]: [
    PERMISSION.CREATE_USER,
    PERMISSION.UPDATE_USER,
    PERMISSION.DELETE_USER,
    PERMISSION.LIST_USERS,
    PERMISSION.USER_DETAIL,
    PERMISSION.CHANGE_PASSWORDS,
    PERMISSION.MI_TIENDA_GET_STORES,
    PERMISSION.MI_TIENDA_ACTIVATE_STORES,
    PERMISSION.PARTNER_PORTAL_GET_STORES,
    PERMISSION.PARTNER_PORTAL_ACTIVATE_STORES,
    PERMISSION.REPORTS,
    PERMISSION.CONTROL_TOWER,
    PERMISSION.RETAILER_MANAGE,
    PERMISSION.HANDLE_ROLES,
    PERMISSION.DEV_PORTAL,
    PERMISSION.MANAGE_SETTLEMENT,
  ],
  [PERMISSION.RETAILER_MANAGE]: [
    PERMISSION.RETAILER_READ,
    PERMISSION.RETAILER_UPDATE,
    PERMISSION.PP_MANAGE,
    PERMISSION.RETAILER_UPDATE_WITH_INCENTIVE_SETTINGS,
  ],
  [PERMISSION.PP_MANAGE]: [
    PERMISSION.PP_UPDATE_WITH_INCENTIVE_SETTINGS,
    PERMISSION.PP_UPDATE,
    PERMISSION.PP_CREATE,
    PERMISSION.PP_READ,
    PERMISSION.PP_DELETE,
    PERMISSION.ORDER_MANAGE,
  ],
  [PERMISSION.ORDER_MANAGE]: [
    PERMISSION.ORDER_CREATE,
    PERMISSION.ORDER_CANCEL,
    PERMISSION.ORDER_REMOVE_DEBT,
    PERMISSION.ORDER_ADD_INCENTIVE,
    PERMISSION.ORDER_POSITION,
    PERMISSION.ORDER_VALIDATE,
    PERMISSION.ORDER_HAND_RT,
    PERMISSION.ORDER_READY,
  ],
};

export const StandalonePermissions = {
  [PERMISSION.RETAILER_UPDATE_WITH_INCENTIVE_SETTINGS]: [PERMISSION.RETAILER_UPDATE],
  [PERMISSION.PP_UPDATE_WITH_INCENTIVE_SETTINGS]: [PERMISSION.PP_UPDATE],
  [PERMISSION.PP_UPDATE]: [PERMISSION.PP_READ],
  [PERMISSION.PP_DELETE]: [PERMISSION.PP_READ],
  [PERMISSION.RETAILER_UPDATE]: [PERMISSION.RETAILER_READ],
};

export const PrerequisitePermissions = {
  [PERMISSION.PP_UPDATE]: PERMISSION.PP_READ,
  [PERMISSION.PP_CREATE]: PERMISSION.PP_READ,
  [PERMISSION.PP_DELETE]: PERMISSION.PP_READ,
  [PERMISSION.UPDATE_USER]: PERMISSION.LIST_USERS,
  [PERMISSION.DELETE_USER]: PERMISSION.LIST_USERS,
};

export const PERMISSIONS_BY_CATEGORY = {
  ORDERS: [
    PERMISSION.CONTROL_TOWER,
    PERMISSION.ORDER_CREATE,
    PERMISSION.ORDER_CANCEL,
    PERMISSION.ORDER_REMOVE_DEBT,
    PERMISSION.ORDER_ADD_INCENTIVE,
    PERMISSION.ORDER_POSITION,
    PERMISSION.ORDER_VALIDATE,
    PERMISSION.ORDER_HAND_RT,
    PERMISSION.ORDER_READY,
  ],
  RETAILER: [PERMISSION.RETAILER_UPDATE, PERMISSION.MANAGE_SETTLEMENT, PERMISSION.RETAILER_UPDATE_WITH_INCENTIVE_SETTINGS],
  PICKING_POINTS: [
    PERMISSION.PP_READ,
    PERMISSION.PP_UPDATE,
    PERMISSION.PP_CREATE,
    PERMISSION.PP_DELETE,
    PERMISSION.PP_UPDATE_WITH_INCENTIVE_SETTINGS,
  ],
  TEAM: [
    PERMISSION.USER_DETAIL,
    PERMISSION.LIST_USERS,
    PERMISSION.CREATE_USER,
    PERMISSION.UPDATE_USER,
    PERMISSION.DELETE_USER,
    PERMISSION.CHANGE_PASSWORDS,
  ],
  OTHER: [
    PERMISSION.REPORTS,
    PERMISSION.MI_TIENDA_GET_STORES,
    PERMISSION.MI_TIENDA_ACTIVATE_STORES,
    PERMISSION.PARTNER_PORTAL_GET_STORES,
    PERMISSION.PARTNER_PORTAL_ACTIVATE_STORES,
  ],
};

export const PERMISSIONS_TO_SHOW_BY_CATEGORY = {
  ORDERS: [
    PERMISSION.CONTROL_TOWER,
    PERMISSION.ORDER_CREATE,
    PERMISSION.ORDER_CANCEL,
    PERMISSION.ORDER_REMOVE_DEBT,
    PERMISSION.ORDER_ADD_INCENTIVE,
    PERMISSION.ORDER_HAND_RT,
    PERMISSION.ORDER_READY,
  ],
  PICKING_POINTS: [
    PERMISSION.PP_READ,
    PERMISSION.PP_UPDATE,
    PERMISSION.PP_CREATE,
    PERMISSION.PP_DELETE,
    PERMISSION.PP_UPDATE_WITH_INCENTIVE_SETTINGS,
  ],
  RETAILER: [PERMISSION.RETAILER_UPDATE, PERMISSION.MANAGE_SETTLEMENT, PERMISSION.RETAILER_UPDATE_WITH_INCENTIVE_SETTINGS],
  TEAM: [PERMISSION.LIST_USERS, PERMISSION.UPDATE_USER, PERMISSION.DELETE_USER, PERMISSION.CHANGE_PASSWORDS],
  OTHER: [PERMISSION.REPORTS, PERMISSION.MI_TIENDA_ACTIVATE_STORES, PERMISSION.PARTNER_PORTAL_ACTIVATE_STORES],
};

export const PERMISSIONS_BY_TIER = {
  GLOBAL: [
    PERMISSION.CREATE_USER,
    PERMISSION.UPDATE_USER,
    PERMISSION.DELETE_USER,
    PERMISSION.LIST_USERS,
    PERMISSION.USER_DETAIL,
    PERMISSION.CHANGE_PASSWORDS,
    PERMISSION.MI_TIENDA_GET_STORES,
    PERMISSION.MI_TIENDA_ACTIVATE_STORES,
    PERMISSION.PARTNER_PORTAL_GET_STORES,
    PERMISSION.PARTNER_PORTAL_ACTIVATE_STORES,
    PERMISSION.REPORTS,
    PERMISSION.CONTROL_TOWER,
    PERMISSION.CHANGE_PASSWORDS,
    PERMISSION.HANDLE_ROLES,
    PERMISSION.RETAILER_UPDATE_WITH_INCENTIVE_SETTINGS,
    PERMISSION.MANAGE_SETTLEMENT,
  ],
  LOCALIZED: [
    PERMISSION.RETAILER_READ,
    PERMISSION.RETAILER_UPDATE,
    PERMISSION.PP_UPDATE,
    PERMISSION.PP_CREATE,
    PERMISSION.PP_READ,
    PERMISSION.PP_DELETE,
    PERMISSION.ORDER_CREATE,
    PERMISSION.ORDER_CANCEL,
    PERMISSION.ORDER_REMOVE_DEBT,
    PERMISSION.ORDER_ADD_INCENTIVE,
    PERMISSION.ORDER_POSITION,
    PERMISSION.ORDER_VALIDATE,
    PERMISSION.ORDER_HAND_RT,
    PERMISSION.ORDER_READY,
    PERMISSION.PP_UPDATE_WITH_INCENTIVE_SETTINGS,
  ],
};
